export const AddTask = ({tasklist,setTasklist,task,setTask}) => {
  const handleSubmit =(e)=>{
    e.preventDefault();
    const form = e.target;
    const title = form.task.value.trim();
    if(!title) return;
    const date = new Date();
    const payload = {
      id: task.id || date.getTime(),
      name: title,
      time: `${date.toLocaleTimeString()} ${date.toLocaleDateString()}`,
      priority: form.priority.value || "Medium",
      deadline: form.deadline.value || "",
      category: form.category.value || "General",
      subtasks: (form.subtasks.value || "").split(",").map(s=>s.trim()).filter(Boolean).map((t,i)=>({id: i+1, text: t, done:false})),
      notified: task.notified || false,
      completed: task.completed || false
    };

    if(task.id){
      const updated = tasklist.map(t=> t.id === task.id ? {...t,...payload} : t);
      setTasklist(updated);
      setTask({});
    } else {
      setTasklist([...tasklist, payload]);
      setTask({});
    }
    form.reset();
  }

  return (
    <section className="addTask">
      <form onSubmit={handleSubmit}>
        <input type="text" name="task" defaultValue={task.name||""} autoComplete="off" placeholder="Task title" maxLength="60" onChange={e=>setTask({...task,name:e.target.value})} />
        <select name="priority" defaultValue={task.priority||"Medium"}>
          <option>High</option>
          <option>Medium</option>
          <option>Low</option>
        </select>
        <input type="datetime-local" name="deadline" defaultValue={task.deadline||""} />
        <select name="category" defaultValue={task.category||"General"}>
          <option>General</option>
          <option>Work</option>
          <option>Personal</option>
          <option>Study</option>
        </select>
        <input type="text" name="subtasks" defaultValue={task.subtasks ? task.subtasks.map(s=>s.text).join(", ") : ""} placeholder="subtasks (comma separated)" />
        <button type="submit">{task.id ? "Update" : "Add"}</button>
      </form>
    </section>
  )
}